import { useCallback, useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import eventBus from '../../../eventBus';

interface QrCodeModalProps {
  waypointUrl: string;
  waypointName: string;
  onClose: () => void;
}

export function QrCodeModal({ waypointUrl, waypointName, onClose }: QrCodeModalProps) {
  const qrRef = useRef<HTMLDivElement>(null);

  const handleDownload = useCallback(() => {
    if (!qrRef.current) return;
    const svg = qrRef.current.querySelector('svg');
    if (!svg) return;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const svgData = new XMLSerializer().serializeToString(svg);
    const img = new Image();

    canvas.width = 256;
    canvas.height = 256;

    img.onload = () => {
      ctx?.drawImage(img, 0, 0, 256, 256);
      const pngUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = `waypoint-qr-${waypointName}.png`;
      link.href = pngUrl;
      link.click();
    };

    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  }, [waypointName]);

  const handleCopyUrl = useCallback(() => {
    navigator.clipboard.writeText(waypointUrl);
    eventBus.emit('flash', 'success', 'Link copied to clipboard!');
  }, [waypointUrl]);

  return (
    <div className="qr-modal-overlay" onClick={onClose}>
      <div className="qr-modal" onClick={(e) => e.stopPropagation()}>
        <header className="qr-modal-header">
          <h3>QR Code</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </header>
        <div className="qr-modal-content">
          <p className="waypoint-name">{waypointName}</p>
          <div className="qr-code-container" ref={qrRef}>
            <QRCodeSVG
              value={waypointUrl}
              size={200}
              level="M"
              includeMargin
            />
          </div>
          <p className="qr-hint">
            Scan this QR code to navigate from this location
          </p>
          <div className="qr-modal-actions">
            <button className="download-btn" onClick={handleDownload}>
              Download PNG
            </button>
            <button className="copy-link-btn" onClick={handleCopyUrl}>
              Copy Link
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
